<jhi-spinner *ngIf="loadingSave"></jhi-spinner>
<jhi-alert></jhi-alert>
<div class="container mt-4 mb-2" *ngIf="configurazioneGeneraleService.configurazione && configurazioneGeneraleService.configurazione.backButtonIsPresent">
  <div class="row justify-content-between">
    <div class="col-auto">
  <nav class="breadcrumb-container" aria-label="Percorso di navigazione">
    <ol class="breadcrumb" *ngIf="istanzaCorrente">
      <li class="breadcrumb-item" *ngIf="configurazioneGeneraleService && configurazioneGeneraleService.configurazione && configurazioneGeneraleService.configurazione.backButtonIsPresent"><a (click)="goToHome()">Home</a><span class="separator">/</span></li>
      <li class="breadcrumb-item"><a (click)="goToServizi()">Servizi</a><span class="separator">/</span></li>
      <li class="breadcrumb-item" *ngFor="let breadcrumbItem of istanzaCorrente.istanza.servizio.servizioAmm?.breadcrumbs"><a href="{{breadcrumbItem.url}}">{{breadcrumbItem.label}}</a><span class="separator">/</span></li>
      <li class="breadcrumb-item active"><a href="javascript:void(0)"><span *ngIf="istanzaCorrente && istanzaCorrente.istanza">{{istanzaCorrente.istanza.servizio.descrizione}}</span></a></li>
    </ol>
  </nav>
    </div>
    <div class="col-auto">
  <button class="btn btn-outline-black" (click)="goToPrenotaAppIst()">Prenota appuntamento</button>
    </div>
  </div>
</div>
<div class="container">
  <div class="row" *ngIf="istanzaCorrente">
    <h3 class="text-center fw-bold my-4">{{istanzaCorrente.istanza.servizio.descrizione}}</h3>
  </div>
</div>
<!--<div class="container px-0" *ngIf="anteprima">
<div class="row">
<div class="col-xl-12">
  <div class="d-flex flex-column">
    <div class="callout callout-highlight warning custom-callout">
      <div class="callout-title">
        <svg class="icon">
          <use href="content/svg/sprites.svg#it-horn"></use>
        </svg>
        <span jhiTranslate="pagamenti.titoloCallout">Attenzione</span></div>
      <p class="p-responsive">Le informazioni che hai fornito
        hanno valore di dichiarazione. Verifica che siano corrette e cliccare <span class="fw-bold">invia</span> per inviare</p>
    </div>
  </div>
</div>
</div>
</div> -->
<div class="container mt-1" [hidden]="erroreTributo" [ngClass]="{'d-none': !istanzaCorrente}">
  <div class="mb-2" *ngIf="istanzaCorrente">
    <h5 class="fw-bold" jhiTranslate="istanze.nuovo.dati">Dati istanza:</h5>
    <div class="row align-items-center justify-content-between">
      <div class="col-3">
        <span class="fw-bold" jhiTranslate="istanze.nuovo.data">Data:</span> {{formatDate(dataIstanza)}}
      </div>
      <div class="col-3">
        <span class="fw-bold">Stato:</span> {{istanzaCorrente.istanza.stato.descrizione}}
      </div>
      <div class="col-auto">
        <button class="btn btn-icon btn-primary primary-button btn-md mx-2" (click)="salvaBozza()" title="{{'istanze.nuovo.bozza' | translate}}">
          <span jhiTranslate="istanze.nuovo.bozza">Salva richiesta</span>
          <svg class="icon icon-white ms-2">
            <use href="./content/svg/sprites.svg#it-pencil"></use>
          </svg>
        </button>
      </div>
    </div>
  </div>
  <div class="container mt-3">
    <dmidynamic-form-render *ngIf="mostraForm"></dmidynamic-form-render>
  </div>
  <div *ngIf="currentStep && (currentStep >= totalSteps - 1)">
  <div *ngIf="width >= 1000 && listaIstanzeAllegato.length">
    <table class="my-4 w-100">
      <caption class="d-none">Lista allegati integrazione</caption>
      <tr>
        <th scope="col" class="text-center" jhiTranslate="istanze.allegati.titolo">Titolo</th>
        <th scope="col" class="text-center" jhiTranslate="istanze.allegati.note">Note</th>
        <th scope="col" class="text-center" jhiTranslate="istanze.allegati.stato">Stato</th>
        <th scope="col" class="text-center" jhiTranslate="istanze.documento">Documento</th>
        <th scope="col" class="text-center" jhiTranslate="istanze.allegati.azioni">Azioni</th>
      </tr>
      <tr *ngFor="let all of listaIstanzeAllegato; index as i" [ngClass]="{'border-bottom' : i !== (listaIstanzeAllegato.length -1)}">
        <td class="col-auto"><div class="d-flex justify-content-center"> {{all.allegato.titolo || ' - '}}</div>
        </td>
        <td class="col-auto">
          <div style="margin-left: 15px; margin-right: 10px;">{{all.allegato.descrizione || ' - '}}</div>
        </td>
        <td class="col-auto">
          <div class="d-flex justify-content-center">
            <span class="badge bg-success" *ngIf="all.allegato.contenuto; else mancante" jhiTranslate="istanze.allegati.inserito">Inserito</span>
            <ng-template #mancante>
              <span class="badge bg-danger" jhiTranslate="istanze.allegati.mancante">Mancante</span>
            </ng-template>
          </div>
        </td>
        <td class="text-center">
          <span *ngIf="all.tipoIstanzaAllegato.flObbligatorio" jhiTranslate="istanze.obbligatorio">Obbligatorio</span>
          <span *ngIf="!all.tipoIstanzaAllegato.flObbligatorio" jhiTranslate="istanze.facoltativo">Opzionale</span>
        </td>
        <td class="col-auto">
          <div class="d-flex justify-content-center" *ngIf="!anteprima">
            <svg class="icon icon-primary icon-color cursor-pointer grow" data-bs-toggle="modal" data-bs-target=".bd-example-modal-lg" (click)="curIndex = i" *ngIf="!all.allegato.contenuto"><use href="content/svg/sprites.svg#it-upload" xlink:href="./content/svg/sprites.svg##it-upload"></use></svg>
            <svg class="icon icon-primary icon-color cursor-pointer grow" data-bs-toggle="modal" data-bs-target=".bd-example-modal-lg" (click)="curIndex = i" *ngIf="all.allegato.contenuto"><use href="content/svg/sprites.svg#it-pencil" xlink:href="./content/svg/sprites.svg##it-pencil"></use></svg>
            <svg class="icon icon-danger cursor-pointer grow" (click)="rimuoviContenuto(i)" *ngIf="all.allegato.contenuto"><use href="content/svg/sprites.svg#it-delete" xlink:href="./content/svg/sprites.svg##it-delete"></use></svg>
            <svg class="icon icon-primary icon-color cursor-pointer grow" (click)="openFile(all.allegato.contenuto, all.allegato.titolo)" *ngIf="all.allegato.contenuto"><use href="content/svg/sprites.svg#it-search" xlink:href="./content/svg/sprites.svg##it-search"></use></svg>
          </div>
          <div *ngIf="anteprima" class="text-center">-</div>
        </td>
      </tr>
    </table>
  </div>
  <div *ngIf="width < 1000">
    <div *ngFor="let all of listaIstanzeAllegato; index as i">
      <div class="box border-upload my-2" jhiDragDrop (fileDropped)="dropFileAllegato($event, i)"
           *ngIf="!all.allegato.contenuto">
        <div class="box d-flex justify-content-center pt-3 pb-3">
          <input type="file" name="file" id="file" class="inputfile inputfile-4 d-none"
                 accept="text/csv, text/plain, application/pdf, image/png, image/jpeg, application/zip"
                 (change)="inserisciFileAllegato($event, i)"
          />
          <label for="file" class="mb-0">
            <figure>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="17" viewBox="0 0 20 17">
                <path
                  d="M10 0l-5.2 4.9h3.3v5.1h3.8v-5.1h3.3l-5.2-4.9zm9.3 11.5l-3.2-2.1h-2l3.4 2.6h-3.5c-.1 0-.2.1-.2.1l-.8 2.3h-6l-.8-2.2c-.1-.1-.1-.2-.2-.2h-3.6l3.4-2.6h-2l-3.2 2.1c-.4.3-.7 1-.6 1.5l.6 3.1c.1.5.7.9 1.2.9h16.3c.6 0 1.1-.4 1.3-.9l.6-3.1c.1-.5-.2-1.2-.7-1.5z"/>
              </svg>
            </figure>
            <p class="text-center mb-0">Carica file</p>
            <p class="fs-6 text-center mb-0">{{all.allegato.descrizione}}</p>
          </label>
          <div class="d-flex justify-content-center" *ngIf="false">
            <div class="progress-spinner progress-spinner-active mt-3 mb-3">
              <span class="visually-hidden">Caricamento...</span>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-center" *ngIf="false">
          <p style="margin-top: -15px !important;"><strong>ATTENZIONE:</strong> Il file supera il limite
            di grandezza
            consentito (<strong>1MB</strong>)!</p>
        </div>
      </div>
      <div class="border-uploaded p-3 my-2" *ngIf="all.allegato.contenuto && all.allegato.contenuto != ''">
        <div class="d-flex justify-content-between w-100">
          <div>
            <li class="upload-file success p-2">
              <svg class="icon icon-sm" aria-hidden="true">
                <use href="./content/svg/sprites.svg##it-file"></use>
              </svg>
              <p>
                <span class="visually-hidden">Caricamento file:</span>
                {{all.allegato.fileName}}<span
                class="upload-file-weight show">{{formatBytes(all.allegato.size, 2)}}</span>
              </p>
            </li>
          </div>
          <div *ngIf="!anteprima">
            <label class="px-2">
              <input type="file" class="d-none" (change)="inserisciFileAllegato($event, i)">
              <svg class="icon icon-primary cursor-pointer icon-color" aria-hidden="true">
                <use href="content/svg/sprites.svg#it-pencil"></use>
              </svg>
            </label>
            <span class="visually-hidden">Annulla caricamento file {{all.allegato.fileName}}</span>
            <svg class="icon icon-danger cursor-pointer" aria-hidden="true"
                 (click)="rimuoviContenuto(i)">
              <use href="content/svg/sprites.svg#it-delete"></use>
            </svg>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <p class="fw-bold text-black mb-1">Titolo: </p>
            <p>{{all.allegato.titolo}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</div>
<div class="container px-0 mt-3 mb-5" *ngIf="!erroreTributo && istanzaCorrente">
  <div class="row" *ngIf="!jsonForm.isWizard">
    <div class="d-flex w-100 justify-content-end col">
      <button (click)="anteprimaIstanza();" class="btn btn-icon btn-md btn-primary primary-button" *ngIf="!this.anteprima" title="{{'istanze.nuovo.invia' | translate}}">
        <span jhiTranslate="istanze.nuovo.avanti">Avanti</span>
        <svg class="icon icon-white ms-2">
          <use href="./content/svg/sprites.svg#it-chevron-right"></use>
        </svg>
      </button>
      <button (click)="this._md_conferma.nativeElement.click()" class="btn btn-icon btn-md btn-success" *ngIf="this.anteprima" title="{{'istanze.nuovo.invia' | translate}}"><span jhiTranslate="istanze.nuovo.invia">Invia</span>
        <svg class="icon icon-white ms-2">
          <use href="./content/svg/sprites.svg#it-check-circle"></use>
        </svg>
      </button>
    </div>
  </div>
  <div *ngIf="jsonForm.isWizard" class="container">
    <div class="d-flex w-100 justify-content-between col" *ngIf="istanzaCorrente.integrazioni![0].documenti">
      <button (click)="stepPrecedente()" class="btn btn-icon btn-md btn-primary primary-button" *ngIf="currentStep && (currentStep >= totalSteps - 1)">
        <svg class="icon icon-white">
          <use href="./content/svg/sprites.svg#it-chevron-left"></use>
        </svg>
        <span>Indietro</span>
      </button>
    <button (click)="stepSuccessivo()" class="btn btn-icon btn-md btn-primary primary-button" title="{{'istanze.nuovo.invia' | translate}}" [disabled]="checkValidity()" *ngIf="currentStep && (currentStep == totalSteps - 1)">
      <span jhiTranslate="istanze.nuovo.avanti">Avanti</span>
      <svg class="icon icon-white ms-2">
        <use href="./content/svg/sprites.svg#it-chevron-right"></use>
      </svg>
    </button>
      <button (click)="sendForm()" class="btn btn-md btn-primary primary-button" title="{{'istanze.nuovo.invia' | translate}}" *ngIf="currentStep && (currentStep == totalSteps)">
        <span>Termina</span>
      </button>
    </div>
  </div>
</div>

<div *ngIf="erroreTributo" class="row justify-content-center my-3">
  <div class="col-lg-10 text-center">
  <div class="card card-bg border-bottom-card p-2 background-primary-before">
    <div class="card-body">
      <h5 class="card-title">Errore nel caricamento dell'istanza</h5>
      <p class="card-text">Si è verificato un errore durante il caricamento dell'istanza.</p>
    </div>
  </div>
  </div>
</div>


<input type="hidden" #_MD_PAGAMENTO data-bs-toggle="modal" data-bs-target="#modal-p">

<div class="it-example-modal">
  <div class="modal alert-modal" tabindex="-1"
       role="dialog" id="modal-p" data-bs-keyboard="false" data-bs-backdrop="static"
       aria-labelledby="confermato">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="d-flex align-items-center modal-title ">
            <svg class="icon icon-success icon-lg me-0">
              <use href="content/svg/sprites.svg#it-check"></use>
            </svg>
            <h4 class="mb-0" *ngIf="istanzaCorrente && istanzaCorrente.istanza && istanzaCorrente.istanza?.id"><span jhiTranslate="istanze.titoloModPgNumber">Istanza salvata con successo con il numero</span><span> {{istanzaCorrente.istanza.id}}</span></h4>
            <h4 class="mb-0" jhiTranslate="istanze.titoloModPg" *ngIf="!istanzaCorrente?.istanza?.id">Istanza salvata con successo</h4>
          </div>
          <input type="hidden" #_MD_PAGAMENTO_CLOSE data-bs-dismiss="modal">
          <button class="btn-close" type="button" (click)="goToHome()">
            <svg class="icon">
              <use href="content/svg/sprites.svg#it-close"></use>
            </svg>
          </button>
        </div>
        <div class="modal-body">
          <span jhiTranslate="istanze.testoModPg">Clicca su 'vai al pagamento' per procedere.</span><br/>
          <span jhiTranslate="istanze.testoModAct">Clicca su 'le mie attività' per procedere.</span>
        </div>
        <div class="modal-footer justify-content-end">
          <button class="btn btn-primary btn-xs primary-button"
                  data-bs-dismiss="modal" type="button"
                  (click)="goToCruscotto()"
          ><span jhiTranslate="istanze.btnAttivita">Le mie attività</span>
            <svg class="icon icon-white icon-sm">
              <use href="./content/svg/sprites.svg#it-files"></use>
            </svg>
          </button>
          <button class="btn btn-success btn-xs"
                  data-bs-dismiss="modal" type="button" (click)="goToPagaSubito()"
          ><span jhiTranslate="istanze.btnPagamento">Vai al pagamento</span>
            <svg class="icon icon-white icon-sm" fill="#ffffff" width="800px" height="800px" viewBox="0 0 24 24"
                 xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,20a9,9,0,1,1,9-9A9,9,0,0,1,12,21Zm.59-13.33a3.34,3.34,0,0,1,2.62,1.38,1,1,0,0,0,1.4.19,1,1,0,0,0,.18-1.41,5.32,5.32,0,0,0-4.2-2.16A5.57,5.57,0,0,0,7.46,9.5H6a1,1,0,0,0,0,2H7c0,.17,0,.33,0,.5s0,.33,0,.5H6a1,1,0,0,0,0,2H7.46a5.57,5.57,0,0,0,5.13,3.83,5.32,5.32,0,0,0,4.2-2.16A1,1,0,1,0,15.21,15a3.34,3.34,0,0,1-2.62,1.38A3.42,3.42,0,0,1,9.67,14.5H12a1,1,0,0,0,0-2H9.05A4.23,4.23,0,0,1,9,12a4.23,4.23,0,0,1,.05-.5H12a1,1,0,0,0,0-2H9.67A3.42,3.42,0,0,1,12.59,7.67Z"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<a aria-hidden="true" tabindex="-1" data-bs-toggle="backtotop" class="back-to-top back-to-top-small" style="left: 3vw;">
  <svg class="icon icon-light">
    <use href="./content/svg/sprites.svg#it-arrow-up"></use>
  </svg>
</a>

<!-- Modale upload allegato -->
<div class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="modalUploadAll" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title h5" id="modalUploadAll">Carica allegato</h2>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Chiudi finestra modale" #_MD_ALLEGATO></button>
      </div>
      <div class="modal-body">
        <div class="box border-upload my-2" jhiDragDrop (fileDropped)="dropFileAllegato($event, curIndex)">
          <div class="box d-flex justify-content-center pt-3 pb-3">
            <input type="file" name="file" id="fileUpload" class="inputfile inputfile-4 d-none"
                   accept="text/csv, text/plain, application/pdf, image/png, image/jpeg, application/zip"
                   (change)="inserisciFileAllegato($event, curIndex)"
            />
            <label for="fileUpload" class="mb-0">
              <figure>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="17" viewBox="0 0 20 17">
                  <path
                    d="M10 0l-5.2 4.9h3.3v5.1h3.8v-5.1h3.3l-5.2-4.9zm9.3 11.5l-3.2-2.1h-2l3.4 2.6h-3.5c-.1 0-.2.1-.2.1l-.8 2.3h-6l-.8-2.2c-.1-.1-.1-.2-.2-.2h-3.6l3.4-2.6h-2l-3.2 2.1c-.4.3-.7 1-.6 1.5l.6 3.1c.1.5.7.9 1.2.9h16.3c.6 0 1.1-.4 1.3-.9l.6-3.1c.1-.5-.2-1.2-.7-1.5z"/>
                </svg>
              </figure>
              <p class="text-center mb-0" jhiTranslate="istanze.allegati.carica">Carica file</p>
              <p class="fs-6 text-center mb-0" *ngIf="listaIstanzeAllegato[curIndex] && listaIstanzeAllegato[curIndex].allegato">{{listaIstanzeAllegato[curIndex].allegato.descrizione}}</p>
            </label>
            <div class="d-flex justify-content-center" *ngIf="false">
              <div class="progress-spinner progress-spinner-active mt-3 mb-3">
                <span class="visually-hidden">Caricamento...</span>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-center" *ngIf="false">
            <p style="margin-top: -15px !important;"><strong>ATTENZIONE:</strong> Il file supera il limite
              di grandezza
              consentito (<strong>1MB</strong>)!</p>
          </div>
        </div>
      </div>
      <div class="modal-footer"></div>
    </div>
  </div>
</div>

<input type="hidden" #_MD_PREFERENZE data-bs-toggle="modal" data-bs-target="#modalePreferenze" >
<!-- Modale salva preferenze -->
<div class="modal fade bd-example-modal-lg" tabindex="-1" data-bs-keyboard="false" role="dialog" aria-labelledby="modalConfirmPre" data-bs-backdrop="static" aria-hidden="true" id="modalePreferenze">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title h5" id="modalConfirmPre">Salva i dati in area personale</h2>
      </div>
      <div class="modal-body">
        <div>
          <p>Vuoi salvare le informazioni anche nella tua area personale? Potrai riutilizzarle in futuro per altre pratiche</p>
        </div>
      </div>
      <div class="modal-footer">
        <div class="d-flex flex-row">
          <button class="btn btn-xs btn-success" (click)="this.salvaPre = true; this._md_preferenze.nativeElement.click(); this.salvaIstanza();">Salva nella mia area personale</button>
          <button class="ms-2 btn btn-xs btn-outline-success" (click)="this.salvaPre = false; this._md_preferenze.nativeElement.click(); this.salvaIstanza();">Salva solo per questa pratica</button>
        </div>
      </div>
    </div>
  </div>
</div>

<input type="hidden" #_MD_CONFERMA data-bs-toggle="modal" data-bs-target="#modaleInvio">
<!-- Modale conferma istanza -->
<div class="modal fade bd-example-modal-lg" tabindex="-1" data-bs-keyboard="false" role="dialog" aria-labelledby="modalConfirmIst" data-bs-backdrop="static" aria-hidden="true" id="modaleInvio">
  <div class="modal-dialog modal-dialog-centered small" role="document">
    <div class="modal-content modal-dimensions">
      <div class="cmp-modal__header modal-header pb-0">
        <button class="btn-close" type="button" data-bs-dismiss="modal" aria-label="Chiudi finestra modale">
        </button>
        <p class="cmp-modal__header-info header-font mb-0">Proseguendo confermi di aver preso visione dei termini e delle condizioni di servizio.</p>
        <a href="#" class="cmp-modal__header-link text-success underline mt-1" data-focus-mouse="false">Leggi termini e condizioni</a>
        <p>Cliccando su "Salva Preferenze e Invia", potrai riutilizzare i dati inseriti nelle prossime pratiche.</p>
        <p>Cliccando su "Conferma e Invia", non potrai riutilizzare i dati inseriti nelle prossime pratiche, salvo non risultino già salvati. </p>
      </div>
      <div class="modal-body">
      </div>
      <div class="modal-footer pb-70 pt-0">
        <button class="btn btn-primary w-100 mx-0 background-primary" type="submit" data-bs-dismiss="modal" (click)="salvaPre = true; salvaIstanza()">Salva Preferenze e Invia</button>
        <button class="btn btn-primary w-100 mx-0 fw-bold mb-4 background-primary" type="submit" data-bs-dismiss="modal" (click)="salvaIstanza()">Conferma e Invia</button>
        <button class="btn btn-outline-primary w-100 mx-0" data-bs-dismiss="modal" type="button">Annulla</button>
      </div>
    </div>
  </div>
</div>
